import { render, staticRenderFns } from "./DocumentInput.vue?vue&type=template&id=ce42a09c&scoped=true&"
import script from "./DocumentInput.vue?vue&type=script&lang=js&"
export * from "./DocumentInput.vue?vue&type=script&lang=js&"
import style0 from "./DocumentInput.vue?vue&type=style&index=0&id=ce42a09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce42a09c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VIcon,VLayout})
